<style>

</style>

<Auth bind:this="{auth}"></Auth>

<Header back="{true}" on:back="{ () => { pop() } }">My Upcoming Events</Header>
<div class="has-header"></div>

<Tabs items="{ [ { name: 'Upcoming', callback: 'upcoming', selected: true }, { name: 'Past Events', callback: 'past', selected: false } ] }" on:upcoming="{ () => push('/events-upcoming') }" on:past="{ () => push('/events-past') }"></Tabs>

{#if events.length}

  {#each events as item, index }
  
  <EventCard item="{item}" currentTime="{currentTime}" on:click="{ () => push('/events-info/'+item.eid) }"></EventCard>
  
  {/each}
  
{:else}
  
<div class="center">
  <h6>You have no upcoming events to show.</h6>
</div>
  
{/if}


<div class="has-action-bar"></div>

<ActionBar></ActionBar>

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import {push, pop, replace, location, link} from 'svelte-spa-router';
export let params = {};

import Xss from "../helpers/Xss.js";

import Auth from "../interfaces/Auth.svelte";
let auth;

import Header from "../components/Header.svelte";
import ActionBar from "../components/ActionBar.svelte";
import Tabs from "../components/Tabs.svelte";
import EventCard from "../components/EventCard.svelte";

let events = [];

let interval = null;
let currentTime =  Math.round( Date.now() / 1000 );

import { onMount } from "svelte";
onMount(async () => {
  
  // update the event times every X minutes
  interval = setInterval( () => { currentTime =  Math.round( Date.now() / 1000 ) }, 1000 * 60 * 1);
  
  loadUpcomingEvents();
  
});


async function loadUpcomingEvents() {
  
  let res = await auth.post("eventsUpcoming", {page: 0});
  if (res != "[]") {
    events = JSON.parse(res);
  }
  
  console.log("events:", events);
  
}

</script>